import React, { Component } from "react";
import './book.css'
import Books from './books.json'
import { getUId, getBBGRating, getDate } from './bbgcommon'

export default class extends Component {
    
    constructor(props){
        super(props);

        var index = -1;
        Books.find(function (b, i) { 
            if(b == props.book){
                index = i;
                return true;               
            } 
        });

        this.state = { 
            book: props.book,
            index: index
        };
    }
    
    render(){
        return  <div className="BookItem-Thumb">
                    <a href={getUId(this.state.book)}>
                        <img width="100" alt={this.state.book.Title} src={`http://images.amazon.com/images/P/`+getUId(this.state.book)+`.01._SCMZZZZZZZ_.jpg`} />
                    </a>
                </div>;
    }
}